function serializeLoadSubsetOptions(options) {
  if (!options) {
    return void 0;
  }
  const result = {};
  if (options.where) {
    result.where = serializeExpression(options.where);
  }
  if (options.orderBy?.length) {
    result.orderBy = options.orderBy.map((clause) => {
      const baseOrderBy = {
        expression: serializeExpression(clause.expression),
        direction: clause.compareOptions.direction,
        nulls: clause.compareOptions.nulls,
        stringSort: clause.compareOptions.stringSort
      };
      if (clause.compareOptions.stringSort === `locale`) {
        return {
          ...baseOrderBy,
          locale: clause.compareOptions.locale,
          localeOptions: clause.compareOptions.localeOptions
        };
      }
      return baseOrderBy;
    });
  }
  if (options.limit !== void 0) {
    result.limit = options.limit;
  }
  if (options.offset !== void 0) {
    result.offset = options.offset;
  }
  return Object.keys(result).length === 0 ? void 0 : JSON.stringify(result);
}
function serializeExpression(expr) {
  if (!expr) {
    return null;
  }
  switch (expr.type) {
    case `val`:
      return {
        type: `val`,
        value: serializeValue(expr.value)
      };
    case `ref`:
      return {
        type: `ref`,
        path: [...expr.path]
      };
    case `func`:
      return {
        type: `func`,
        name: expr.name,
        args: expr.args.map((arg) => serializeExpression(arg))
      };
    default:
      return null;
  }
}
function serializeValue(value) {
  if (value === void 0) {
    return { __type: `undefined` };
  }
  if (typeof value === `number`) {
    if (Number.isNaN(value)) {
      return { __type: `nan` };
    }
    if (value === Number.POSITIVE_INFINITY) {
      return { __type: `infinity`, sign: 1 };
    }
    if (value === Number.NEGATIVE_INFINITY) {
      return { __type: `infinity`, sign: -1 };
    }
  }
  if (value === null || typeof value === `string` || typeof value === `number` || typeof value === `boolean`) {
    return value;
  }
  if (value instanceof Date) {
    return { __type: `date`, value: value.toJSON() };
  }
  if (Array.isArray(value)) {
    return value.map((item) => serializeValue(item));
  }
  if (typeof value === `object`) {
    return Object.fromEntries(
      Object.entries(value).map(([key, val]) => [
        key,
        serializeValue(val)
      ])
    );
  }
  return value;
}
export {
  serializeLoadSubsetOptions
};
//# sourceMappingURL=serialization.js.map
